{
  "RRSP": "REER",
  "TFSA": "CELI",
  "PERSONAL": "Trésorerie",
  "RESP": "REEE",
  "RESP_SINGLE": "REEE individuel",
  "RESP_FAMILY": "REEE familial",
  "RESP_ADULT": "REEE pour adulte",
  "CORPORATE_CASH": "Trésorerie d'entreprise",
  "CORPORATE_TRUST": "Fiducies",
  "CORPORATE_ESTATE": "Succession d'entreprise",
  "CORPORATE_CHARITY": "Philanthropie d'entreprise",
  "RRSP_SPOUSAL": "REER conjoint",
  "LIRA": "CRI",
  "RRIF": "FERR",
  "RIF_SPOUSAL": "FERR conjoint",
  "LIF": "FRV",
  "PRIF": "FERR prescrit",
  "GRSP": "RERC",
  "CASH_JOINT": "Trésorerie conjointe",
  "RDSP": "REEI",
  "RESP_SINGLE_JOINT": "REEE conjoint individuel",
  "RESP_FAMILY_JOINT": "REEE conjoint familial",
  "ARTICLES_OF_INCORPORATION_OR_EQUIVALENT": "Statuts juridiques ou équivalent",
  "BENEFICIARY_DESIGNATION_FORM": "Formulaire de désignation du bénéficiaire",
  "BENEFICIARY_RRSP": "REER Bénéficiaire",
  "BENEFICIARY_TFSA": "CELUI Bénéficiaire",
  "CLB_FOR_ADULTS": "BEC pour adultes",
  "CLIENT_ACCOUNT_AGREEMENT": "Contrat de compte client",
  "CORPORATE_ACCOUNT_AGREEMENT": "Contrat de compte d'entreprise",
  "CORPORATE_RESOLUTION": "Résolution d'entreprise",
  "DEATH_CERTIFICATE": "Certificat de décès",
  "DECLARATION_OF_TAX_DISCLOSURE": "Avis de déclaration fiscale",
  "DECLARATION_OF_TAX_DISCLOSURE_E": "Avis de déclaration fiscale E",
  "DISCRETIONARY_MANAGEMENT_AGREEMENT": "Mandat de gestion discrétionnaire",
  "EDUCATION_SAVINGS_GRANTS_APPLICATION": "Application de la Subvention pour l'épargne-études",
  "ELECTRONIC_DELIVERY_AGREEMENT": "Accord de livraison électronique",
  "EXTERNAL_TRANSFER_TO_NON_REGISTERED_ACCOUNTS": "Virement externe vers un compte non enregistré",
  "EXTERNAL_TRANSFER_TO_REGISTERED_ACCOUNTS": "Virement externe vers un compte enregistré",
  "FEE_REDIRECTION": "Redirection des frais",
  "FHSA": "CELIAPP",
  "GOAL_INVESTMENT_POLICY_STATEMENT": "Énoncé de la politique de placement axée sur les objectifs",
  "INVESTMENT_POLICY_STATEMENT": "Énoncé de la politique de placement",
  "JOINT_CLIENT_ACCOUNT_AGREEMENT": "Contrat de compte client conjoint",
  "LAST_WILL": "Dernières volontés",
  "LIF_ADDENDUM": "Addenda FRV",
  "LIRA_ADDENDUM": "Addenda CRI",
  "LOD_QESI": "Lettre d'instructions IQEE",
  "LRIF": "FRRI",
  "LRIF_ADDENDUM": "Addenda FRRI",
  "LRSP": "RERI",
  "LRSP_ADDENDUM": "Addenda RERI",
  "NON_INDIVIDUAL_ENTITY_ACCOUNT_AGREEMENT": "Contrat de compte d'entité non individuelle",
  "ONEVEST_RELATIONSHIP_DISCLOSURE_BROCHURE": "Brochure d'information sur les relations avec Onevest",
  "PAD_AGREEMENT": "Convention de DPA",
  "PRIF_ADDENDUM": "Addenda FERR",
  "RESP_FAMILY_PLAN": "REEE familial",
  "RESP_SINGLE_PLAN": "REEE individuel",
  "RLIF": "FRVR",
  "RLIF_ADDENDUM": "Addenda FRVR",
  "RLSP": "REIR",
  "RLSP_ADDENDUM": "Addenda REIR",
  "SWP_AGREEMENT": "Convention SWP",
  "TRUST_AGREEMENT": "Convention de fiducie",
  "TRUST_DEED": "Acte de fiducie",
  "TRUST_PARTICIPANT_IDENTIFICATION_FORM": "Formulaire d'identification des participants à la fiducie",
  "W8BEN": "W8Ben",
  "W9": "W9",
  "WAIVER_OF_CONFIDENTIALITY": "Renonciation à la confidentialité",
  "W_8BEN_E": "W_8BenE",
  "W_8IMY": "W_8Imy"
}
